/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type ListMetaMcpServersSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type ListMetaMcpServersSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type ListMetaMcpServersSecurity = {
  option1?: ListMetaMcpServersSecurityOption1 | undefined;
  option2?: ListMetaMcpServersSecurityOption2 | undefined;
};

export type ListMetaMcpServersRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type ListMetaMcpServersSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const ListMetaMcpServersSecurityOption1$outboundSchema: z.ZodMiniType<
  ListMetaMcpServersSecurityOption1$Outbound,
  ListMetaMcpServersSecurityOption1
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function listMetaMcpServersSecurityOption1ToJSON(
  listMetaMcpServersSecurityOption1: ListMetaMcpServersSecurityOption1,
): string {
  return JSON.stringify(
    ListMetaMcpServersSecurityOption1$outboundSchema.parse(
      listMetaMcpServersSecurityOption1,
    ),
  );
}

/** @internal */
export type ListMetaMcpServersSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const ListMetaMcpServersSecurityOption2$outboundSchema: z.ZodMiniType<
  ListMetaMcpServersSecurityOption2$Outbound,
  ListMetaMcpServersSecurityOption2
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function listMetaMcpServersSecurityOption2ToJSON(
  listMetaMcpServersSecurityOption2: ListMetaMcpServersSecurityOption2,
): string {
  return JSON.stringify(
    ListMetaMcpServersSecurityOption2$outboundSchema.parse(
      listMetaMcpServersSecurityOption2,
    ),
  );
}

/** @internal */
export type ListMetaMcpServersSecurity$Outbound = {
  Option1?: ListMetaMcpServersSecurityOption1$Outbound | undefined;
  Option2?: ListMetaMcpServersSecurityOption2$Outbound | undefined;
};

/** @internal */
export const ListMetaMcpServersSecurity$outboundSchema: z.ZodMiniType<
  ListMetaMcpServersSecurity$Outbound,
  ListMetaMcpServersSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => ListMetaMcpServersSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => ListMetaMcpServersSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function listMetaMcpServersSecurityToJSON(
  listMetaMcpServersSecurity: ListMetaMcpServersSecurity,
): string {
  return JSON.stringify(
    ListMetaMcpServersSecurity$outboundSchema.parse(listMetaMcpServersSecurity),
  );
}

/** @internal */
export type ListMetaMcpServersRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const ListMetaMcpServersRequest$outboundSchema: z.ZodMiniType<
  ListMetaMcpServersRequest$Outbound,
  ListMetaMcpServersRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
    });
  }),
);

export function listMetaMcpServersRequestToJSON(
  listMetaMcpServersRequest: ListMetaMcpServersRequest,
): string {
  return JSON.stringify(
    ListMetaMcpServersRequest$outboundSchema.parse(listMetaMcpServersRequest),
  );
}
